import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';

export const noAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const navigation = inject(NavigationService);

  if (authService.isTokenValid()) {
    navigation.goToMyAccount();
    return false;
  }
  return true;
};
